import './index.scss';
import ModalManager from 'utils/modal_manager';
import { errorInterpreter } from 'utils/error_interpreter';

export default class RequestCommentsModal {
  static open(questionId, questionTitle, callback) {
    $('.js-question-title', '#js-request-comments-modal').html(questionTitle);

    ModalManager.open('#js-request-comments-modal', res => {
      if (!res) {
        return;
      }

      Thor.Question.request_professor_commentary(
        {},
        {
          data: {
            resource_id: questionId
          }
        }
      )
        .then(() => {
          toastr.success('Comentário solicitado com sucesso!');

          $(
            '.js-request-teacher-comment',
            `div[data-question-id=${questionId}]`
          ).addClass('disabled');

          if ($.isFunction(callback)) {
            callback();
          }
        })
        .catch(({ response }) => {
          if (response?.responseJSON?.errors?.user) {
            toastr.info('Você já fez esta solicitação anteriormente!');
          } else {
            errorInterpreter({
              message:
                'Ops! Não foi possível solicitar comentário nesse momento!',
              response
            });
          }
        });
    });
  }
}
